export default __webpack_public_path__ + "static/media/1085.da96dd35.png";